import { Routes } from '@angular/router';
import { configuredGuard } from './guards/configured.guard';
import { posConfigurationResolver } from './resolvers/pos-configuration.resolver';
import { SelfCheckoutTerminalInitService as TerminalInitService } from '@softapps/wws/pos-core';
import { SelfCheckoutTerminalRepository as TerminalRepository } from '@softapps/wws/pos-core';
import { ledControlOffFn } from './guards/led-control.guard';
import { ProductService } from './services/product.service';
import { ProductRepository } from './repositories/product.repository';
import {
  createCache,
  SOFTLINE_WWS_CASH_REGISTER_CATEGORIES_IMG_CACHE,
} from '@softapps/wws/pos-core';
import {
  SOFTLINE_WWS_SELF_CHECKOUT_CATEGORIES_IMG_CACHE,
  SOFTLINE_WWS_SELF_CHECKOUT_IMG_CACHE,
  SOFTLINE_WWS_SELF_CHECKOUT_IS_CASHIER,
  SOFTLINE_WWS_SELF_CHECKOUT_ROUTE_PATH,
} from './self-checkout.tokens';
import { signal } from '@angular/core';

const selfCheckoutConfigRoutes: Routes = [
  {
    path: 'self-checkout/config',
    loadComponent: () => import('./pages/config/config.component'),
  },
];

export const selfCheckoutRoutes: Routes = [
  ...selfCheckoutConfigRoutes,
  {
    path: 'self-checkout',
    canActivate: [configuredGuard],
    providers: [
      TerminalRepository,
      TerminalInitService,
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_ROUTE_PATH,
        useValue: { routePath: 'cart' },
      },
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_IS_CASHIER,
        useValue: signal(false),
      },
    ],
    resolve: {
      configuration: posConfigurationResolver,
    },
    canDeactivate: [ledControlOffFn],
    loadChildren: () => [
      {
        path: 'cart',
        loadComponent: () => import('./pages/cart-page/cart-page.component'),
      },
      {
        path: 'cart/finalized',
        loadComponent: () => import('./pages/finalized-page/finalized-page.component'),
      },
      {
        path: 'cart/:cartId',
        loadComponent: () => import('./pages/cart-page/cart-page.component'),
      },
      {
        path: 'cart/:cartId/payment',
        loadComponent: () => import('./pages/payment-page/payment-page.component'),
      },
      {
        path: 'cart/:cartId/choose-bon',
        loadComponent: () => import('./pages/choose-bon-page/choose-bon-page.component'),
      },
      {
        path: '',
        loadComponent: () => import('./pages/splash-page/splash-page.component'),
        data: {
          nextRoute: 'cart',
        },
      },
    ],
  },
];

export const selfCheckoutTouchRoutes: Routes = [
  ...selfCheckoutConfigRoutes,
  {
    path: 'self-checkout-touch',
    canActivate: [configuredGuard],
    providers: [
      TerminalRepository,
      TerminalInitService,
      ProductService,
      ProductRepository,
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_IMG_CACHE,
        useFactory: createCache<string>,
      },
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_CATEGORIES_IMG_CACHE,
        useFactory: createCache<string>,
      },
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_ROUTE_PATH,
        useValue: { routePath: 'touch' },
      },
      {
        provide: SOFTLINE_WWS_SELF_CHECKOUT_IS_CASHIER,
        useValue: signal(false),
      },
    ],
    resolve: {
      configuration: posConfigurationResolver,
    },
    canDeactivate: [ledControlOffFn],
    loadChildren: () => [
      {
        path: 'touch',
        loadChildren: () => [
          {
            path: ':cartId',
            loadComponent: () => import('./pages/touch-page/touch-page.component'),
          },
          {
            path: '',
            loadComponent: () => import('./pages/touch-page/touch-page.component'),
          },
        ],
      },
      {
        path: 'cart/finalized',
        loadComponent: () => import('./pages/finalized-page/finalized-page.component'),
      },
      {
        path: 'cart/:cartId',
        loadComponent: () => import('./pages/touch-cart-page/touch-cart-page.component'),
      },
      {
        path: 'cart/:cartId/payment',
        loadComponent: () => import('./pages/payment-page/payment-page.component'),
      },
      {
        path: 'cart/:cartId/choose-bon',
        loadComponent: () => import('./pages/choose-bon-page/choose-bon-page.component'),
      },
      {
        path: '',
        loadComponent: () => import('./pages/splash-page/splash-page.component'),
        data: {
          nextRoute: 'touch',
        },
      },
    ],
  },
];

export const selfCheckoutPublicRoutes: Routes = [
  {
    path: 'digital-receipt',
    loadComponent: () => import('./pages/digital-receipt/digital-receipt.component'),
  },
  {
    path: 'digital-receipt/:key',
    loadComponent: () => import('./pages/digital-receipt/digital-receipt.component'),
  },
];
